import axiosInstance from "../../../../axiosInstance";

const checkRequired = (value) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return 'Required';
  }
};

const validateLength = (key, value, min, max) => {
  if (value.length < min) {
    return `${key} ust be at least ${min} characters`;
  }
  if (value.length > max) {
    return `${key} must be no more than ${max} characters`;
  }
};

const removeUndefined = (arr) =>
  Object.keys(arr)
    .filter((key) => arr[key] !== undefined)
    .reduce((res, key) => {
      res[key] = arr[key];
      return res;
    }, {});

const checkNameExists = async (name, versionId, saveAsTemplate) => {
  try {
    // Execluding the current versionId from the check
    let response
    if (saveAsTemplate){
      response = await axiosInstance.get(`/api/workflows-template/checkName/${name}`);
    }
    else{
      response = await axiosInstance.get(`/api/workflows/version/checkName/${name}/exld/${versionId}`);
    }

    if (response.status === 200 && response.data.exists) {
      return 'Name is available';
    }
  } catch (error) {
    return 'Name already exists';
  }
};

const validateImageSize = (workflowImage, maxSizeMB = 5) => {
  if (!workflowImage || !Array.isArray(workflowImage) || workflowImage.length === 0) {
    return undefined;
  }

  const image = workflowImage[0];
  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  if (image.size && image.size > maxSizeBytes) {
    return `Image size (${(image.size / 1024 / 1024).toFixed(2)}MB) exceeds ${maxSizeMB}MB limit`;
  }

  return undefined;
};

const validate = async ({ name, description, versionId , saveAsTemplate, workflowImage}) => {
  const errors = removeUndefined({
    name: checkRequired(name) || (name && validateLength('Name', name, 3, 50)),
    workflowImage: validateImageSize(workflowImage, 5),
  });

    if (description.length >= 500) {
    errors.description = "Please add at least one form stage node to the workflow.";
    return errors;
  }

  console.log("errors:", errors);
  

  if (!errors.name) {
    const nameError = await checkNameExists(name, versionId, saveAsTemplate);
    if (nameError) {
      console.log("Name error:", nameError);
      errors.name = nameError;
    }
  }

  return errors;
};

export default validate;